import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function LojaListGrupoExibicaoFilter() {
    const [filterCod, setFilterCod] = useState<FilterValuesProps>({
        property: 'idConfiguracaoPropriedadeGrupoExibicao',
        operator: 'eq',
        value: null,
    });

    const [filterGrupoExibicao, setFilterGrupoExibicao] = useState<FilterValuesProps>({
        property: 'dsConfiguracaoPropriedadeGrupoExibicao',
        operator: 'like',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'like',
        value: null,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            filters={[
                { value: filterCod, setter: setFilterCod },
                { value: filterGrupoExibicao, setter: setFilterGrupoExibicao },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código"
                    value={filterCod.value}
                    onChange={(e) => setFilterCod((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Buscar por"
                    value={filterGrupoExibicao.value}
                    onChange={(e) => setFilterGrupoExibicao((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <StatusField
                    label="Status"
                    value={filterStatus.value}
                    onChange={(e, value) => setFilterStatus((oldState) => ({ ...oldState, value: value }))}
                />
            </Grid>
        </Filter>
    );
}
